<template>
  <b-row>
      <b-col>
          <b-button-toolbar>
              <b-button-group class="mb-3" size="sm">
                  <b-button v-if="selected.length < rowCount" @click="selectAll()" variant="outline-secondary">
                      <b-icon-list-check></b-icon-list-check>
                      <span class="ml-2 mr-1">Select All</span>
                  </b-button>
                  <b-button v-else-if="selected.length > 0" @click="clearSelected()" variant="outline-secondary">
                      <b-icon-list></b-icon-list>
                      <span class="ml-2 mr-1">Clear Selected</span>
                  </b-button>
                  <b-button variant="outline-secondary" @click="removeWants()">
                    <b-icon-file-minus></b-icon-file-minus>
                    <span class="ml-2 mr-1">Remove From Want List</span>
                  </b-button>
              </b-button-group>
              <div class="counts">{{ countText }} <span v-if="selected.length > 0" class="ml-5 text-secondary">{{ selected.length }} selected</span></div>               
          </b-button-toolbar>
        
      </b-col>

  </b-row>
</template>

<script>
  export default {
      name: "WantListMenu",
      props: [ 'selected', 'rowCount', 'selectRange' ],
      methods: {
          selectAll() {
              this.$emit('selectAll');
          },
          clearSelected() {
              this.$emit('clearSelected');
          },
          removeWants() {
            this.$emit('removeFromWants');
          },
      },
      computed: {
          countText() {
              if (parseInt(this.rowCount) === 1) {
                  return `${this.rowCount} item`;
              }

              return `${this.rowCount} items`;
          }
      }
  }
</script>

<style scoped>
  .counts {
      padding: 3px 0;
      margin-left: 40px;
      margin-bottom: 15px;
      display: flex;
      flex-grow: 1;
  }
</style>